import React, { useMemo } from 'react'

import { useCartRedux, useAuth } from '@hooks'
import { MEMBER_ROLE } from '@common'
import CartList from './CartList'
import RedeemPoints from './RedeemPoints'
import ComplimentaryOrder from './ComplimentaryOrder'

const CartContent = () => {
    const { items } = useCartRedux()
    const { memberData } = useAuth()

    // Check if member is Management role
    const isManagement = useMemo(() => {
        if (!memberData?.assignments || !Array.isArray(memberData.assignments) || memberData.assignments.length === 0) {
            return false
        }
        // Handle both number and string role.id types
        return memberData.assignments.some(assignment => {
            const roleId = assignment?.role?.id
            // Check if roleId matches Management role (could be number or string)
            return (
                roleId === MEMBER_ROLE.Management ||
                roleId === String(MEMBER_ROLE.Management) ||
                parseInt(roleId) === MEMBER_ROLE.Management
            )
        })
    }, [memberData])

    if (items.length === 0) return null

    return (
        <>
            <CartList />
            <RedeemPoints />
            {isManagement && <ComplimentaryOrder />}
        </>
    )
}

export default CartContent
